import React,{ useState, useEffect } from "react";

const YlwNews = (props) => {
    const ylwNews = [
        {name:'영림원소프트랩', keyword:'ksystem', url:'http://www.ksystem.co.kr'},
        //{name:'스마트컨택센터', keyword:'smartcontact', url:'http://www.ksystem.co.kr'},
        {name:'교육센터', keyword:'educenter', url:'https://www.ksystemedu.co.kr/gnu'}
    ];
    const [newsdata,setNewsdata ] = useState(null);
    const [tab, setTab] = useState(ylwNews[0]);
    
    useEffect(()=>{
        getYlwNews();
    },[]);
    const getYlwNews = async() =>{
        const response = await fetch(`api/Login/GetKSystemNotice`, {
            method:'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        });
        const result = await response.json();        
        setNewsdata(result);
    } 
    const clickNotice = (link) => {
            window.open(link);
    }
    const selectTab = (e, news) => {        
        setTab(news);
    }
    return (
        <section className="ylwnews">
            <h2 className="section-title">영림원소프트랩에서 알립니다</h2>
            <div className="ylwnews-content">
                <ul className="ylwnews-tab">
                    {ylwNews.map((news,index) => {return (
                        <li key={`tab-${index}`} className={`ylwnews-tab-${news.keyword == tab.keyword ? "selected":"default"}`} onClick={(e)=>selectTab(e,news)}>{news.name}</li>
                    );})}
                </ul>
                <ul className="ylwnews-list">
                    {
                        newsdata != null ? newsdata[tab.keyword].map((news, index) => {
                            return(
                                <li key={`${tab.keyword}-${index}`} onClick={() => clickNotice( tab.url + news.title.split('|')[1])}>
                                    <p className="ylwnews-title">{news.title.split('|')[0]}</p>
                                    <p className="date">{news.date}</p>
                                </li>
                            )
                        }).slice(0,5) : null
                    }
                </ul>
            </div>
        </section>
    );
}

export default YlwNews;